import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PHOTO_MANAGER_SUBSCRIPTION_FEATURES } from '../../../../apps/pro/views/Account/AccountPhotoManagerSettings/components/PhotoManagerSubscriptionCheckout/helpers';
import Button from '../../../../components/global/Button';

const propTypes = {
  className: PropTypes.string,
  supportText: PropTypes.node,
};

const RegisterFeatures = ({ className, supportText }) => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const classes = classNames({
    [className]: !!className,
    'view-register-features-wrap': true,
  });

  const featuresShown = showAllFeatures
    ? PHOTO_MANAGER_SUBSCRIPTION_FEATURES
    : PHOTO_MANAGER_SUBSCRIPTION_FEATURES.slice(0, 6);

  return (
    <div className={classes}>
      <ul className="view-register-features">
        {featuresShown.map(feature => {
          return <li key={feature}>{feature}</li>;
        })}
        {!showAllFeatures && (
          <li className="d-flex align-items-center">
            And many more features!{' '}
            <Button
              btnStyle="reset"
              className="ml-1 text-extra-bold text-yellow"
              onClick={() => setShowAllFeatures(true)}
            >
              View All
            </Button>
          </li>
        )}
      </ul>

      {supportText}
    </div>
  );
};

RegisterFeatures.propTypes = propTypes;

export default RegisterFeatures;
